import { motion, useScroll, useTransform } from "framer-motion";
import { Waveform, EqCurve, SpectrumBars, VerticalLabel } from "./AudioArt";
import { EASE } from "./Reveal";

const pop = (delay) => ({
  initial: { opacity: 0, y: 40, rotate: 0 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 1.1, ease: EASE, delay },
});

export default function HeroCollage({ scrollRef }) {
  const { scrollYProgress } = useScroll({ target: scrollRef, offset: ["start start", "end start"] });
  const yPortrait = useTransform(scrollYProgress, [0, 1], [0, 90]);
  const yConsole = useTransform(scrollYProgress, [0, 1], [0, -70]);
  const yCard = useTransform(scrollYProgress, [0, 1], [0, 140]);

  return (
    <div className="relative h-[520px] sm:h-[600px] lg:h-[680px] w-full select-none" data-testid="hero-collage">
      <motion.div style={{ y: yConsole }} {...pop(0.35)} className="absolute right-0 top-4 w-[68%] aspect-[4/3] rounded-[28px] overflow-hidden duotone-lilac shadow-2xl -rotate-3">
        <img src="/empress-console-eq.webp" alt="Empress dialing in an EQ at Da Cave Studios" className="w-full h-full object-cover" loading="eager" />
      </motion.div>

      <Waveform className="absolute -left-10 right-0 top-[38%] w-[120%] h-40 opacity-90 pointer-events-none" delay={0.9} />

      <motion.div style={{ y: yPortrait }} {...pop(0.55)} className="absolute left-2 sm:left-6 bottom-6 w-[58%] aspect-[4/5] rounded-[32px] overflow-hidden shadow-[0_40px_80px_-30px_rgba(0,0,0,0.8)] ring-1 ring-white/10 rotate-2">
        <img src="/empress-headshot.webp" alt="Empress, recording and mixing engineer" className="w-full h-full object-cover object-top photo-grade" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian/60 via-transparent to-transparent" />
        <SpectrumBars count={18} className="absolute left-5 bottom-5 h-10" />
      </motion.div>

      <motion.div style={{ y: yCard }} {...pop(0.8)} className="absolute right-2 sm:right-4 bottom-10 w-[46%] rounded-2xl glass-dark p-4 sm:p-5 rotate-[4deg] shadow-xl" data-testid="hero-eq-card">
        <div className="flex items-center justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Vocal Chain · EQ</p>
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 shadow-[0_0_10px_2px_rgba(52,211,153,0.7)]" />
        </div>
        <EqCurve className="w-full h-auto mt-3" />
      </motion.div>

      <VerticalLabel className="absolute left-0 top-0 h-56 text-white/35 hidden lg:block">Mixed By Empress — Da Cave Studios</VerticalLabel>
      <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ duration: 1, ease: EASE, delay: 1.2 }} className="absolute right-[26%] top-0 w-24 h-24 rounded-full border border-gold/50 flex items-center justify-center">
        <span className="font-serif italic text-gold text-sm leading-tight text-center">Est.<br />Nashville</span>
      </motion.div>
    </div>
  );
}
